import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { INavData } from '@coreui/angular-pro';
import { UserCompany, UserProfiles } from '@shared/models';
import { StorageService } from '@shared/services';
import { environment } from 'src/environments/environment';
import { navItemsAdmin } from './_nav-admin';
import { navItemsMedic } from './_nav-medic';
import { navItemsSuperadmin } from './_nav-superadmin';
interface NavOptions {
  [key: string]: INavData[];
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styles: [
    `
      /* z-index required to display MatSnackbar */
      .z-900 {
        z-index: 900;
      }
    `,
  ],
})
export class DefaultLayoutComponent {
  public navItems: INavData[] = [];
  private _storageService = inject(StorageService);
  private _router = inject(Router);
  version = environment.version;

  ngOnInit(): void {
    const user = this._storageService.getUser();
    if (user) {  
      this.navItems = this.getNavItemsForRole(user.profile);

      if (user.company === UserCompany.PAMPAMED) {
        this.navItems = this.navItems.filter((item) => item.url !== '/studies');
      }
     
    }
  }

  private getNavItemsForRole(role: UserProfiles): INavData[] {
    const navOptions: NavOptions = {
      [UserProfiles.SUPERADMIN]: navItemsSuperadmin,
      [UserProfiles.ADMIN]: navItemsAdmin,
      [UserProfiles.MEDICO]: navItemsMedic,
    };
    return navOptions[role] || [];
  }

  logout(): void {
    localStorage.clear();
    this._router.navigate(['/auth']);
  }
}
